require('bootstrap-treeview/dist/bootstrap-treeview.min');
var Marionette = require('backbone.marionette');

var RelationsFormView = require('../relations/relations-form');
var OrganizationDataView = require('./organization-data');
var RelationsListView = require('../relations/relations-list-view');
var PermissionsTableView = require('../permissions/permissions-table-view');

var OrganizationForm = require('./organization-form');
var Organization = require('../../models/organization');
var DeleteConfirmationModal = require('../common/delete-confirmation-modal');
var PermissionFormView = require('../permissions/permission-form');

var RelationsCollection = require('../../collections/relations-collection');
var PermissionsCollection = require('../../collections/permissions-collection');

var CommonUtils = require('../../utils/common-utils.js');

var ContactsTableView = require('../contacts/contacts-table-view');
var ContactsCollection = require('../../collections/contacts-collection');
var ContactFormView = require('../contacts/contact-form');

var AddressTableView = require('../contacts/address-table-view');
var AddressesFormView = require('../contacts/address-form');

var RepresentativesTableView = require('../contacts/representatives-table-view');
var RepresentativeFormView = require('../contacts/representative-form');

var CommentFormView = require('../comments/comment-form');
var CommentsTableView = require('../comments/comments-table-view');

var MedProfileImportSettingsForm = require("./medical-profile-import-settings-form");

var ExternalIdsView = require("../common/external-ids-view");
var OrganizationPersonsView = require('./organization-persons-view');

var Radio = require('backbone.radio');
var sessionChannel = Radio.channel('session');
var notificationsChannel = Radio.channel('notifications');

var OrganizationView = Marionette.View.extend({
    template: require('../../templates/organizations/organization.html'),
    model: new Organization(),
    regions: {
        organizationData: '#organization-data',
        organizationForm: '#organization-form',
        editSection: '#edit-section',
        organizationRelations: '#organization-relations',
        addOrganizationRelation: '#add-organization-relation',
        personRelations: '#person-relations',
        addPersonRelation: '#add-person-relation',
        deleteOrganizationConfirmationModal: '.delete-confirmation-modal',
        permissions: '#permissions',
        addPermission: '#add-permission',
        contacts: '#contacts',
        contactForm: '#contact-form',
        addresses: '#addresses',
        addressForm: '#address-form',
        representatives: '#representatives',
        representativeForm: '#representative-form',
        comments: '#comments',
        addComment: '#add-comment',
        organizationImportSettings: '#organization-import-settings-content',
        externalsIdsRegion: '#external-ids',
        personsRegion: '#persons'
    },

    ui: {
        organizationEdit: '#organization-data',
        saveBtn: '#save-organization',
        contactForm: '#contact-form',
        commentsCount: '#comments-count',
        commentsContainer: '#comments-list'
    },

    events: {
        'click #edit-data': 'toggleEdit',
        'click #cancel-edit': 'toggleEdit',
        'click #save-organization': 'saveChanges',
        'click #remove-organization': 'removeOrganisation',
        'comment:count:changed': 'onCommentCountChanged'
    },

    childViewEvents: {
        'relation:saved': 'relationSaved',
        'delete:confirmed': 'deleteConfirmed',
        'permission:saved': 'permissionSaved',
        'on:contact:action': 'onContactAction',
        'on:contact:saved': 'onContactSaved',
        'on:address:action': 'onAddressAction',
        'on:address:saved': 'onAddressSaved',
        'on:representative:action': 'onRepresentativeAction',
        'on:representative:saved': 'onRepresentativeSaved',
        'organization:save:valid': 'saveOrganizationBtnEnableOrDisable',
        'contact:hover': 'onContactHover',
        'address:hover': 'onAddressHover',
        'representative:hover': 'onRepresentativeHover',
        'comment:added': 'onCommentAdded',
        'comment:count:changed': 'onCommentCountChanged',
        'on:cancel:comment:send': 'onCancelCommentSend',
        'on:edit:comment': 'onEditComment',
        'comment:updated': 'onCommentUpdated',
        'on:new:comment': 'onNewComment',

        'save:import:settings': 'onSaveImportSettings',
        'cancel:import:settings': 'onCancelImportSettings',

        'on:save:externalids': 'onSaveExternalIds',
        'on:cancel:externalids': 'onCancelExternalIds'
    },

    userCanEdit: undefined,

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'renderOrg', 'toggleEdit', 'saveChanges', 'removeOrganisation', 'relationSaved',
            'deleteConfirmed', 'permissionSaved', 'renderContacts', 'renderContactForm', 'onContactAction', 'onContactSaved',
            'renderPermissionsListView', 'saveOrganizationBtnEnableOrDisable', 'onContactHover', 'onAddressHover',
            'onAddressAction', 'onAddressSaved', 'onCommentAdded', 'onCommentCountChanged', 'onSaveImportSettings', 'onCancelImportSettings', 'canEdit');
        this.permissions = sessionChannel.request('get:permissions');
        this.model = options.model;
        this.byAdmin = options.byAdmin;
        this.user = options.user;
        this.commonUtil = new CommonUtils();
    },

    onRender: function () {
        window.document.title = this.model.get("name");
        this.renderOrg();
        this.initEvents();
    },

    templateContext: function () {
        var that = this;
        return {
            canEdit: that.canEdit,
            byAdmin: this.byAdmin
        }
    },


    renderOrg: function () {
        this.organizationForm = new OrganizationForm({
            model: this.model,
            isEditMode: true
        });
        this.personRelationsCollection = new RelationsCollection(this.model.get('relations').filter(function (item) {
            return item.type.childType === 'person';
        }));
        this.orgRelationsCollection = new RelationsCollection(this.model.get('relations').filter(function (item) {
            return item.type.childType === 'organization';
        }));

        this.showChildView('organizationData', new OrganizationDataView({
            model: this.model,
            canEdit: this.canEdit(),
            byAdmin: this.byAdmin,
            user: this.user
        }));
        this.showChildView('organizationForm', this.organizationForm);

        //Organization relations
        this.orgRelationsList = new RelationsListView({collection: this.orgRelationsCollection});
        this.showChildView('organizationRelations', this.orgRelationsList);

        this.orgRelationsFormView = new RelationsFormView({parentId: this.model.id, childrenTypes: ['organization']});
        this.showChildView('addOrganizationRelation', this.orgRelationsFormView);

        //Person relations
        this.personRelationsList = new RelationsListView({collection: this.personRelationsCollection});
        this.showChildView('personRelations', this.personRelationsList);

        this.personRelationsFormView = new RelationsFormView({
            parentId: this.model.id,
            childrenTypes: ['person'],
            parentTypes: ['organization']
        });
        this.showChildView('addPersonRelation', this.personRelationsFormView);

        this.deleteOrganizationConfirmationModal =
            new DeleteConfirmationModal({
                message: 'Enter: "confirm" if you agree to remove the organization.',
                confirmationAnswer: 'confirm'
            });
        this.showChildView('deleteOrganizationConfirmationModal', this.deleteOrganizationConfirmationModal);

        this.renderContacts();
        this.renderAddresses();
        this.renderRepresentatives();
        this.renderPersons(this.model);

        if (this.canEdit()) {
            this.permissionsCollection = new PermissionsCollection([], {
                params: [{
                    key: 'permittedObjectId',
                    value: this.model.id
                }]
            });
            this.renderPermissionsListView(this.permissionsCollection);

            this.permissionFormView = new PermissionFormView({
                'permittedObjectId': this.model.id,
                showOrganization: true,
                permittedObjectType: 'organization'
            });
            this.showChildView('addPermission', this.permissionFormView);

            this.commentModel = new Backbone.Model({
                id: undefined,
                text: undefined
            });

            this.showChildView('comments', new CommentsTableView({
                dboId: this.model.get('id'),
                canEdit: this.canEdit()
            }));

            this.renderCommentForm();
        }

        if (this.byAdmin) {
            this.renderImportSettings();
            this.renderExternalIdsView(this.model.get('object').externalIds || []);
        }
    },

    renderImportSettings: function () {
        this.showChildView('organizationImportSettings', new MedProfileImportSettingsForm({
            ccrPermissions: this.model.get('object').ccrPermissions,
            ccdPermissions: this.model.get('object').ccdPermissions
        }));
    },

    renderCommentForm: function (model) {
        this.showChildView('addComment', new CommentFormView({
            dboId: this.model.get('id'),
            model: model ? model : new Backbone.Model({
                id: undefined,
                text: undefined
            })
        }));
    },

    initEvents: function () {
        this.triggerMethod('comment:count:changed');
    },

    renderPermissionsListView: function (collection) {
        this.permissionsListView = new PermissionsTableView({
            collection: collection,
            showOrganization: true,
            permittedObjectType: 'organization'
        });
        this.showChildView('permissions', this.permissionsListView);
    },

    renderExternalIdsView: function (externalIds) {
        this.externalIdsView = new ExternalIdsView({
            externalIds: _.clone(externalIds)
        });
        this.showChildView('externalsIdsRegion', this.externalIdsView);
    },

    toggleEdit: function () {
        this.ui.organizationEdit.toggle();
        $('#edit-section').toggle();
    },

    saveChanges: function () {
        var that = this;
        that.model = that.organizationForm.fillModel();
        that.model.save(that.model.toJSON(), {
            success: function (response) {
                that.toggleEdit();
                that.renderContacts();
                that.renderAddresses();
                that.renderRepresentatives();
            },
            error: function (model, xhr, options) {
                notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
            }
        });
    },

    removeOrganisation: function () {
        this.$('#delete-confirmation-modal').modal();
    },

    relationSaved: function (data) {
        var entityType = data.get('type').childType;
        if (entityType === 'person') {
            this.personRelationsCollection.add(data);
            this.showChildView('addPersonRelation', new RelationsFormView({
                parentId: this.model.id,
                childrenTypes: ['person'],
                parentTypes: ['organization']
            }));
        }
        else {
            this.orgRelationsCollection.add(data);
            this.showChildView('addOrganizationRelation', new RelationsFormView({
                parentId: this.model.id,
                childrenTypes: ['organization']
            }));
        }
    },

    permissionSaved: function (model) {
        this.renderPermissionsListView(this.permissionsCollection);
    },

    deleteConfirmed: function (value) {
        if (value == true) {
            var that = this;
            this.model.destroy({
                dataType: "text",
                success: function () {
                    that.remove();
                    that.unbind();
                    Backbone.history.navigate('/', {
                        trigger: true
                    });
                }
            });
        }
    },

    canEdit: function () {
        if (!this.userCanEdit) {
            this.userCanEdit = this.commonUtil.userCanDo(this.permissions,
                function (permission) {
                    return permission.canWriteFor;
                },
                this.model.get('permissions'),
                function (permission) {
                    return permission.canWrite;
                }
            );
        }
        return this.userCanEdit;
    },

    renderContacts: function () {
        this.contactsView = new ContactsTableView({
            collection: new ContactsCollection(this.model.get('object').contacts),
            canEdit: this.canEdit()
        });
        this.showChildView("contacts", this.contactsView);
    },

    renderAddresses: function () {
        this.addressesView = new AddressTableView({
            collection: new ContactsCollection(this.model.get('object').addresses),
            canEdit: this.canEdit()
        });
        this.showChildView("addresses", this.addressesView);
    },

    renderRepresentatives: function () {
        this.representativesView = new RepresentativesTableView({
            collection: new ContactsCollection(this.model.get('object').representatives),
            canEdit: this.canEdit()
        });
        this.showChildView("representatives", this.representativesView);
    },

    renderPersons: function (model) {
        this.personsView = new OrganizationPersonsView({
            organizationModel: model,
            canEdit: this.canEdit()
        });
        this.showChildView('personsRegion', this.personsView);
    },

    renderContactForm: function (mode, contact) {
        this.ui.contactForm.show();
        if (mode == 'add') {
            this.contactFormView = new ContactFormView({
                mode: mode,
                addresses: this.model.get('object').addresses || [],
                representatives: this.model.get('object').representatives || []
            });
            this.showChildView("contactForm", this.contactFormView);
        }
        else if (mode == 'edit') {
            this.contactFormView = new ContactFormView({
                mode: mode,
                contact: contact,
                addresses: this.model.get('object').addresses || [],
                representatives: this.model.get('object').representatives || []
            });
            this.showChildView("contactForm", this.contactFormView);
        }
    },

    renderAddressForm: function (mode, address) {
        if (mode == 'add') {
            this.addressFormView = new AddressesFormView({
                mode: mode
            });
            this.showChildView("addressForm", this.addressFormView);
        }
        else if (mode == 'edit') {
            this.addressFormView = new AddressesFormView({
                mode: mode,
                address: address
            });
            this.showChildView("addressForm", this.addressFormView);
        }
    },

    renderRepresentativeForm: function (mode, representative) {
        if (mode == 'add') {
            this.representativeFormView = new RepresentativeFormView({
                mode: mode
            });
            this.showChildView("representativeForm", this.representativeFormView);
        }
        else if (mode == 'edit') {
            this.representativeFormView = new RepresentativeFormView({
                mode: mode,
                representative: representative
            });
            this.showChildView("representativeForm", this.representativeFormView);
        }
    },

    removeContactForm: function () {
        this.ui.contactForm.hide();
        this.detachChildView('contactForm');
    },

    removeAddressForm: function () {
        this.detachChildView('addressForm');
    },

    removeRepresentativeForm: function () {
        this.detachChildView('representativeForm');
    },

    onContactAction: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.renderContactForm(data.mode);
        }
        else if (data.mode == 'delete') {
            var willBeRemoveContact = data.data.attributes;
            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
                return contact.data !== willBeRemoveContact.data
                    || contact.type !== willBeRemoveContact.type
                    || contact.preferred !== willBeRemoveContact.preferred;
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                }
            });
        }
        else if (data.mode == 'edit') {
            var willBeEditedContact = data.data.attributes;
            var willEditContact = (that.model.get('object').contacts || []).filter(function (contact) {
                return contact.data == willBeEditedContact.data
                    && contact.type == willBeEditedContact.type
                    && contact.preferred == willBeEditedContact.preferred;
            });
            this.renderContactForm(data.mode, willEditContact[0]);
        }
        else if (data.mode == 'cancel') {
            that.removeContactForm();
        } else if (data.mode == 'save') {
            var changedContact = data.data.attributes;
            (that.model.get('object').contacts || []).forEach(function (contact) {
                if (contact.data == changedContact.data
                    && contact.type == changedContact.type) {
                    contact.preferred = changedContact.preferred;
                }
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                }
            });
        }
    },

    onContactSaved: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
                return contact.data !== data.contact.data
                    || contact.type !== data.contact.type
                    || contact.preferred !== data.contact.preferred;
            });
            that.model.get('object').contacts.push(data.contact);
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                    that.removeContactForm();
                }
            });
        } else if (data.mode == 'edit') {
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                    that.removeContactForm();
                }
            });
        }
    },

    onAddressAction: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.renderAddressForm(data.mode);
        }
        else if (data.mode == 'delete') {
            var willBeRemovedAddress = data.data.attributes;
            that.model.get('object').addresses = (that.model.get('object').addresses || []).filter(function (address) {
                return address.uuid !== willBeRemovedAddress.uuid;
            });
            that.model.get('object').contacts.forEach(function (contact) {
                contact.addresses = (contact.addresses || []).filter(function (addressUuid) {
                    return addressUuid != willBeRemovedAddress.uuid;
                })
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderAddresses();
                    that.renderContacts();
                }
            });
        }
        else if (data.mode == 'edit') {
            var willBeEditedAddress = data.data.attributes;
            var willEditAddress = (that.model.get('object').addresses || []).filter(function (address) {
                return address.uuid == willBeEditedAddress.uuid;
            });
            this.renderAddressForm(data.mode, willEditAddress[0]);
        }
        else if (data.mode == 'cancel') {
            that.removeAddressForm();
        }
    },

    onAddressSaved: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.model.get('object').addresses = (that.model.get('object').addresses || []).filter(function (address) {
                return address !== null && address.uuid !== data.address.uuid;
            });
            that.model.get('object').addresses.push(data.address);
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderAddresses();
                    that.renderContacts();
                    that.removeAddressForm();
                }
            });
        } else if (data.mode == 'edit') {
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderAddresses();
                    that.renderContacts();
                    that.removeAddressForm();
                }
            });
        }
    },

    onRepresentativeAction: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.renderRepresentativeForm(data.mode);
        }
        else if (data.mode == 'delete') {
            var willBeRemovedRepresentative = data.data.attributes;
            that.model.get('object').representatives = (that.model.get('object').representatives || []).filter(function (representative) {
                return representative.uuid !== willBeRemovedRepresentative.uuid;
            });
            that.model.get('object').contacts.forEach(function (contact) {
                contact.representatives = (contact.representatives || []).filter(function (representativeUuid) {
                    return representativeUuid != willBeRemovedRepresentative.uuid;
                })
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderRepresentatives();
                    that.renderContacts();
                }
            });
        }
        else if (data.mode == 'edit') {
            var willBeEditedRepresentative = data.data.attributes;
            var willEditRepresentative = (that.model.get('object').representatives || []).filter(function (representative) {
                return representative.uuid == willBeEditedRepresentative.uuid;
            });
            this.renderRepresentativeForm(data.mode, willEditRepresentative[0]);
        }
        else if (data.mode == 'cancel') {
            that.removeRepresentativeForm();
        }
    },

    onRepresentativeSaved: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.model.get('object').representatives = (that.model.get('object').representatives || []).filter(function (representative) {
                return representative !== null && representative.uuid !== data.representative.uuid;
            });
            that.model.get('object').representatives.push(data.representative);
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderRepresentatives();
                    that.renderContacts();
                    that.removeRepresentativeForm();
                }
            });
        } else if (data.mode == 'edit') {
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderRepresentatives();
                    that.renderContacts();
                    that.removeRepresentativeForm();
                }
            });
        }
    },

    onContactHover: function (data) {

        $('.address-row').each(function () {
            $(this).children().each(function () {
                $(this).removeClass('hovered-contact-marked');
            });
        });

        $('.representative-row').each(function () {
            $(this).children().each(function () {
                $(this).removeClass('hovered-contact-marked');
            });
        });

        (data.addresses || []).forEach(function (addressUuid) {
            $('.' + addressUuid).each(function () {
                if (data.hovered) {
                    $(this).addClass('hovered-contact-marked');
                } else {
                    $(this).removeClass('hovered-contact-marked');
                }
            });
        });

        (data.representatives || []).forEach(function (representativeUuid) {
            $('.' + representativeUuid).each(function () {
                if (data.hovered) {
                    $(this).addClass('hovered-contact-marked');
                } else {
                    $(this).removeClass('hovered-contact-marked');
                }
            });
        });
    },

    onAddressHover: function (event) {

        $('.contact-row').each(function () {
            $(this).removeClass('hovered-contact-marked');
        });

        this.model.get('object').contacts.forEach(function (contact, index) {
            if ((contact.addresses || []).indexOf(event.uuid) > -1) {
                if (event.hovered) {
                    $($('.contact-row')[index]).addClass('hovered-contact-marked');
                } else {
                    $($('.contact-row')[index]).removeClass('hovered-contact-marked');
                }
            }
        })
    },

    onRepresentativeHover: function (event) {

        $('.contact-row').each(function () {
            $(this).removeClass('hovered-contact-marked');
        });

        this.model.get('object').contacts.forEach(function (contact, index) {
            if ((contact.representatives || []).indexOf(event.uuid) > -1) {
                if (event.hovered) {
                    $($('.contact-row')[index]).addClass('hovered-contact-marked');
                } else {
                    $($('.contact-row')[index]).removeClass('hovered-contact-marked');
                }
            }
        });
    },

    saveOrganizationBtnEnableOrDisable: function (data) {
        if (data.result)
            this.ui.saveBtn.removeAttr("disabled");
        else
            this.ui.saveBtn.attr("disabled", "true");
    },

    onCommentAdded: function (commentModel) {
        this.getChildView('comments').add(commentModel);
        this.renderCommentForm();
    },

    onCommentUpdated: function (commentModel) {
        this.getChildView('comments').update(commentModel);
        this.renderCommentForm();
    },

    onCommentCountChanged: function () {
        var that = this;

        $.ajax({
            type: "GET",
            url: '/api/comment/' + that.model.get('id') + '/count',
            statusCode: {
                200: function (response) {
                    that.ui.commentsCount.text(response);
                    if (typeof that.getChildView('comments') != 'undefined') {
                        that.getChildView('comments').syncWithCount(response);
                    }
                }
            },
            error: function (e) {
                console.log(e);
            }
        });
    },

    onCancelCommentSend: function () {
        this.renderCommentForm();
    },

    onEditComment: function (model) {
        var that = this;
        that.renderCommentForm(model);
        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
    },

    onNewComment: function () {
        this.renderCommentForm();
        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
    },

    onSaveImportSettings: function (data) {
        var that = this;
        var originalCcrPermissions = _.clone(that.model.get('object').ccrPermissions);
        var originalCcdPermissions = _.clone(that.model.get('object').ccdPermissions);
        that.model.get('object').ccrPermissions = data.ccrPermissions;
        that.model.get('object').ccdPermissions = data.ccdPermissions;
        that.model.save(that.model.toJSON(), {
            success: function (response) {
                $.notify("Import settings updated successfully", "success");
                that.renderImportSettings();
            },
            error: function (model, xhr, options) {
                that.model.get('object').ccrPermissions = originalCcrPermissions;
                that.model.get('object').ccdPermissions = originalCcdPermissions;
                notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
            }
        });
    },

    onCancelImportSettings: function () {
        this.renderImportSettings();
    },


    onSaveExternalIds: function (data) {
        var that = this;
        var idsList = data.externalIds;
        var doSave = data.doSave;

        if (doSave) {
            that.model.get('object').externalIds = _.reject(idsList, function (id) {
                return _.isEmpty(id);
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderExternalIdsView(that.model.get('object').externalIds || []);
                    $.notify("External ids saved successfully", "success");
                },
                error: function (collection, response, options) {
                    if (response.status == 401) {
                        actionsChannel.request("redirect:to:login");
                    } else {
                        notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
                    }
                }
            });
        } else {
            that.renderExternalIdsView(idsList);
        }
    },

    onCancelExternalIds: function () {
        this.renderExternalIdsView(this.model.get('object').externalIds || []);
    }
});

module.exports = OrganizationView;


//////////////////
// WEBPACK FOOTER
// ./app/views/organizations/organization.js
// module id = 220
// module chunks = 0